export default {
    APP_NAME: window.APP_NAME,
    API_DOMAIN: window.API_DOMAIN,
    API_ROOT: window.API_DOMAIN + "/api/v1",
    DEFAULT_ORG: window.DEFAULT_ORG,
    AUTH_URL: window.API_DOMAIN + '/oauth/authorize',
    API_BASE_URL: window.API_DOMAIN + '/api/v1/organizations',
    APP_ID: window.SENSA_APP_ID,
    REDIRET: window.CLIENT_DOMAIN,
    AUTH_USER_URL: window.API_DOMAIN + '/api/v1/oauth/auth-user'
}


// WEBPACK FOOTER //
// ./src/.env.js